var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.56648 0H1.43322C0.838939 0 0.352539 0.485943 0.352539 1.08069V14.9189C0.352539 15.5136 0.838939 16 1.43322 16H8.56648C9.16077 16 9.64717 15.5145 9.64717 14.9193V1.08069C9.64717 0.485943 9.16077 0 8.56648 0ZM3.85882 0.778971H6.14088C6.21311 0.778971 6.27162 0.837486 6.27162 0.910171C6.27162 0.9824 6.21311 1.04091 6.14088 1.04091H3.85882C3.7866 1.04091 3.72808 0.9824 3.72808 0.910171C3.72808 0.837486 3.7866 0.778971 3.85882 0.778971ZM4.99985 15.4597C4.70134 15.4597 4.45951 15.2178 4.45951 14.9189C4.45951 14.6199 4.70134 14.3785 4.99985 14.3785C5.29837 14.3785 5.5402 14.6199 5.5402 14.9189C5.5402 15.2178 5.29837 15.4597 4.99985 15.4597ZM8.89517 14H1.10454V1.71383H8.89517V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPhone);
export default __webpack_public_path__ + "static/media/ic-phone.729ae315dd11ca993479648daae2c820.svg";
export { ForwardRef as ReactComponent };